


import {MessagePartyVM} from './MessagePartyVM'; 
export class MessageVM {
    
    id?: string;
    
    sessionId?: string;
    
    from?: MessagePartyVM;
    
    to?: MessagePartyVM;
    
    subject?: string;
    
    body?: string;
    
    markAsRead?: boolean;
    
    date?: Date;
    
    allowReply?: boolean;
    
    replyingTo?: string;
    
    roomId?: string;
    
}
